import type { ImageProps as _ImageProps } from "@chakra-ui/react";
import { forwardRef, Image as _Image } from "@chakra-ui/react";

export interface ImageProps extends _ImageProps {}

export const Image = forwardRef<ImageProps, "img">((props, ref) => <_Image {...props} ref={ref} />);
